import { CountryConfig } from "../../shared/types";
import { indonesiaFormRegistry } from "./formRegistry";
import { IDR_DATA_SLICE_KEY } from "./const";
import { ReactComponent as IndonesiaFlag } from "../../assets/indonesia-flag.svg";

export const indonesiaConfig: CountryConfig = {
  code: "IDR",
  name: "Indonesia",
  dataSliceKey: IDR_DATA_SLICE_KEY,
  flag: IndonesiaFlag,
  currencyCode: "IDR",
  formRegistry: indonesiaFormRegistry,
  paymentMethods: [
    { name: "Bank transfer", value: "bank" },
    { name: "eWallet", value: "wallet" },
  ],
  steps: [
    {
      id: "amount",
      type: "amount",
      title: "Amount",
      stepTitle: "How much are you sending?",
    },
    {
      id: "payment_details",
      type: "payment_details",
      title: "Payment Details",
      stepTitle: "Payment Details",
    },
    {
      id: "beneficiary",
      type: "beneficiary",
      title: "Beneficiary",
      stepTitle: "Beneficiary details",
    },
    {
      id: "review",
      type: "review",
      title: "Review",
      stepTitle: "Review the details of your transaction",
    },
  ],
};
